import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { paymentActions } from "../../../redux/actions";
import { LockIcon, BreakdownIcon } from "../../../assets/images/icon";
import {
  paymentType,
  translationConstants,
  paymentCardRadioButtonConstants,
  viewPathConstants,
  freelanceStatusEnum,
  Directions,
  paymentFormDivIds,
  calculationOperations,
} from "../../../constants";
import {
  getUserPayload,
  unloadWidget,
  renderPaymentform,
  hyperpayFormCustomJS,
  calculateVAT,
  precisionCalculation,
  dateToUTCWithTimezone,
  serverFormatToMomentObject,
  hyperpaySaveCardFormCustomJS,
} from "../../../system";

import CustomModal from "../CustomModal/CustomModal";
import FreelancerPricingModal from "./FreelancerPricingModal";

const BecomeFreelanceInstructorPayment = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userPayload = getUserPayload();

  const [cardUsageState, setCardUsageState] = useState(
    paymentCardRadioButtonConstants.NEWCARD
  );
  const [totalFee, setTotalFee] = useState(null);
  const [isLoadCustomJS, setLoadCustomJS] = useState(false);
  const [isPricingBreakdown, setPricingBreakdown] = useState(false);

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const userData = useSelector((state) => state?.LoginReducer?.UserData);
  const checkoutId = useSelector((state) => state.PaymentReducer.CheckoutID);
  const checkoutIdSavedCard = useSelector(
    (state) => state.PaymentReducer.checkoutIdSavedCard
  );
  const savedcards = useSelector(
    (state) => state.PaymentReducer.savedPaymentCards
  );

  const nextBillingDueDate = () => {
    let currentDate = dateToUTCWithTimezone();
    if (userData?.freelanceStatus === freelanceStatusEnum.Restricted) {
      currentDate?.subtract(60, "days").add(1, "year");
      return currentDate;
    } else if (
      userData?.freelanceStatus === freelanceStatusEnum.PaymentRejected
    ) {
      const nextBillingDueDate = serverFormatToMomentObject(
        userData?.freelanceNextPaymentDueDateString
      )?.add(1, "year");
      return nextBillingDueDate;
    } else {
      currentDate?.add(1, "year");
      return currentDate;
    }
  };

  const renderForm = (id, formDivId, cardType) => {
    renderPaymentform(
      id,
      viewPathConstants.PROFILE,
      "?freelancer=true&",
      formDivId,
      setLoadCustomJS,
      cardType
    );
  };

  const resetForm = () => {
    setLoadCustomJS("");
    dispatch(paymentActions.paymentCheckoutNull());
    unloadWidget();
  };

  useEffect(() => {
    dispatch(
      paymentActions.getSavedPaymentCard({
        systemUserId: userPayload?.user?.id,
      })
    );
    dispatch(paymentActions.paymentCheckoutNull());
    unloadWidget();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLoadCustomJS === paymentCardRadioButtonConstants.NEWCARD) {
      hyperpayFormCustomJS(
        t,
        direction,
        true,
        false,
        false,
        nextBillingDueDate
      );
    } else if (isLoadCustomJS === paymentCardRadioButtonConstants.SAVEDCARDS) {
      hyperpaySaveCardFormCustomJS(t, direction);
    }
    //eslint-disable-next-line
  }, [isLoadCustomJS]);

  useEffect(() => {
    if (totalFee !== null) {
      if (
        cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
        checkoutId !== null
      ) {
        renderForm(
          checkoutId,
          paymentFormDivIds.newCardForm,
          paymentCardRadioButtonConstants.NEWCARD
        );
      } else if (
        cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
        checkoutIdSavedCard !== null
      ) {
        renderForm(
          checkoutIdSavedCard,
          paymentFormDivIds.savedCardForm,
          paymentCardRadioButtonConstants.SAVEDCARDS
        );
      }
    }
    //eslint-disable-next-line
  }, [cardUsageState, checkoutId, checkoutIdSavedCard]);

  useEffect(() => {
    if (totalFee) {
      const commonPayload = {
        price: totalFee?.toFixed(2),
        systemUserId: userPayload?.user?.id,
        paymentType: paymentType.Freelance,
      };

      if (
        cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
        checkoutId === null
      ) {
        dispatch(
          paymentActions.paymentCheckout({
            ...commonPayload,
            createRegistration: true,
          })
        );
      } else if (
        cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
        checkoutIdSavedCard === null
      ) {
        dispatch(paymentActions.paymentCheckoutSavedCard(commonPayload));
      }
    }
    //eslint-disable-next-line
  }, [totalFee, cardUsageState]);

  useEffect(() => {
    const vatPrice = calculateVAT(props?.vat, props?.price?.current);
    const total = precisionCalculation(
      vatPrice,
      props?.price?.current,
      calculationOperations.addition
    );
    setTotalFee(total);
    const dataToSend = {
      spotId: props.spotId,
      sportIds: props.sportIds,
      systemUserId: userData?.user?.id,
      price: total,
    };
    localStorage.setItem("freelanceCheckoutDetail", JSON.stringify(dataToSend));
    //eslint-disable-next-line
  }, [props.price]);

  return (
    <div className="mx-2">
      <span className="loginPara">{props.title}</span>

      <div className="row mx-0 my-2">
        <Col md={6} className="p-0">
          <p className="text-dark font-weight-700">
            <span className="font-weight-700">
              {`${t(translationConstants.TOTAL_FEE)}: ${t(
                translationConstants.YEARLY_WITH_BRACKETS
              )}`}
            </span>
          </p>
        </Col>
        <Col
          md={6}
          className={`p-0 d-flex align-items-center justify-content-end`}
        >
          <div
            className={`d-flex align-items-center justify-content-end gap-2 fw-bold text-end text-dark`}
          >
            <div
              className={`d-flex flex-column ${
                direction === Directions.rtl ? "text-start" : "text-end"
              }`}
            >
              {translationConstants.SAR} {totalFee?.toFixed(2)}
              <span className="font-10">
                {t(translationConstants.VAT_INCLUDED)}
              </span>
            </div>
            <span className="d-flex align-items-center info-icon">
              <img
                alt="img-info"
                src={BreakdownIcon}
                onClick={() => {
                  props?.onSetShowSmallModal
                    ? props?.onSetShowSmallModal((prev) => !prev)
                    : setPricingBreakdown(true);
                }}
              />
            </span>
          </div>
        </Col>
      </div>

      <div className="row mx-0 my-2">
        <Col md={6} className="p-0">
          <p className="text-dark font-weight-700">
            <span className="font-weight-700">
              {t(translationConstants.PAYMENT_METHOD)}:
            </span>
          </p>
        </Col>
        <Col
          md={6}
          className="d-flex align-items-center justify-content-end p-0"
        >
          <div className="d-flex gap-1 align-items-center">
            <img
              className="secured-by-hyperpay-img"
              src={LockIcon}
              alt="secure lock icon"
            />
            <span className="secured-by-hyperpay-text">
              {t(translationConstants.SECURED_BY_HYPERPAY)}
            </span>
          </div>
        </Col>
      </div>

      {savedcards?.count > 0 && (
        <div className="d-flex gap-3">
          <Form.Check
            type="radio"
            label={t(translationConstants.USE_SAVED_CARD)}
            name={`radioGroup`}
            id={"savedcard"}
            value={paymentCardRadioButtonConstants.SAVEDCARDS}
            onChange={(e) => {
              resetForm();
              setCardUsageState(e.currentTarget?.value);
            }}
          />
          <Form.Check
            type="radio"
            label={t(translationConstants.USE_NEW_CARD)}
            name={`radioGroup`}
            id={"newcard"}
            value={paymentCardRadioButtonConstants.NEWCARD}
            defaultChecked={true}
            onChange={(e) => {
              resetForm();
              setCardUsageState(e.currentTarget?.value);
            }}
          />
        </div>
      )}

      {cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
        totalFee !== null &&
        checkoutId && (
          <div id={paymentFormDivIds.newCardForm} className="pt-2"></div>
        )}

      {cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
        totalFee !== null &&
        checkoutIdSavedCard && (
          <div id={paymentFormDivIds.savedCardForm} className="pt-4"></div>
        )}

      <CustomModal
        size={"sm"}
        scrollable={true}
        setShow={setPricingBreakdown}
        show={isPricingBreakdown}
        customClass={"freelance-instructor-model-sm"}
        closeBtnClasses={"login-modal-close-btn"}
      >
        <FreelancerPricingModal priceBreakdown={props?.pricingBreakdown} />
      </CustomModal>
    </div>
  );
};

export default BecomeFreelanceInstructorPayment;
